import { BroadcastService } from '../../core/services/broadcast.service';
import { Injectable, OnDestroy } from '@angular/core';
import { MyCampAppConstants } from './constants';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Injectable()
export abstract class ServiceManagerBase implements OnDestroy
{
    protected defaultPageSize: number = MyCampAppConstants.defaultDataPageSize;
    protected retrievingData = false;
    protected suppressOrganizationChanged = false;

    protected constructor(protected broadcastService: BroadcastService)
    {
        this.broadcastService.userSignedOut.pipe(untilDestroyed(this)).subscribe(() => this.clearCache());
        this.broadcastService.organizationChanged.pipe(untilDestroyed(this)).subscribe(() => { if (!this.suppressOrganizationChanged) this.clearCache(); });
    }

    ngOnDestroy()
    {
    }

    protected abstract clearCache(): void;
}
